<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <b-container fluid class="filters-grid-container">
        <b-row>
          <b-col cols="2"></b-col>
          <b-col cols="8">
            <div class="filters-container">
              <div class="filter-header">
                <h3 class="advanced-search-title">Advanced Search</h3>
                <div class="input-group mb-3 keyword-search-input-container">
                  <input
                    v-model="keyword"
                    @keyup.enter="applyFilter"
                    type="text"
                    class="form-control keyword-search-input"
                    placeholder="Search keyword..."
                    aria-label="Search keyword"
                  >
                  <div class="search-type-container">
                    <h6 class="search-type-title">Search type:</h6>
                    <b-form-radio-group
                      v-model="selectedSearchType"
                      :options="searchTypeOptions"
                      name="radio-inline"
                    ></b-form-radio-group>
                  </div>
                </div>
              </div>
              <div class="filter-rows">
                <div class="filter-line" v-for="filter in filters" :key="filter.name">
                  <div class="filter-row">
                    <label class="switch switch-label switch-primary">
                      <input
                        type="checkbox"
                        class="switch-input"
                        :value="filter.name"
                        v-model="selectedFilters"
                      >
                      <span class="switch-slider"></span>
                    </label>
                    <p class="filter-name">{{ filter.name }}</p>
                  </div>
                </div>
              </div>
              <div class="buttons-container">
                <b-button @click="applyFilter" variant="primary">Apply filter</b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>
      </b-container>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["filtersData"],
  data() {
    return {
      filters: { ...this.filtersData },
      selectedFilters: [],
      keyword: "",
      selectedSearchType: "begins-with",
      searchTypeOptions: [
        { text: "Begins with", value: "begins-with" },
        { text: "Contains", value: "contains" },
        { text: "Exact match", value: "exact-match" }
      ]
    };
  },
  methods: {
    toggleVisibility() {
      this.advancedFiltersVisible = !this.advancedFiltersVisible;
    },
    applyFilter() {
      // Handle apply filter action (Save filters to store and refresh Grid)
    }
  }
};
</script>

<style>
.toggle-filter-row {
  text-align: right;
  margin-bottom: 15px;
}

.filters-grid-container {
  background-color: #f0f3f5;
  padding: 15px 5px 5px 5px !important;
  margin-bottom: 10px;
}

.filter-header * {
  display: inline-block;
}

.filter-header .advanced-search-title {
  display: inline-table;
  vertical-align: top;
}

.filter-header .keyword-search-input-container {
  width: 75%;
  text-align: right;
}

.filter-header .keyword-search-input-container .keyword-search-input {
  margin-left: 15px;
  width: 100%;
}

.filter-header .keyword-search-input-container .search-type-container {
  margin-top: 5px;
}

.filter-header
  .keyword-search-input-container
  .search-type-container
  .search-type-title {
  margin-right: 10px;
}

.filter-rows {
  padding-top: 15px;
  margin-bottom: 15px;
  overflow: auto;
  border-top: 1px solid #757575;
  border-bottom: 1px solid #757575;
}

.filter-rows .filter-line {
  width: 25%;
  float: left;
  overflow: hidden;
  white-space: nowrap;
}

.filter-rows .filter-row .switch {
  display: inline-block;
  vertical-align: middle;
}

.filter-rows .filter-row .filter-name {
  display: inline-block;
  margin-left: 5px;
  font-weight: 600;
}

.buttons-container {
  margin-bottom: 15px;
  text-align: right;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>